module.exports = __webpack_public_path__ + "media/images/country_flags/hu-185c30b402af6bbf32f26ec8712083de.png";